export interface LinkConfig {
  whitelistedDomains: string[];
}

const config: LinkConfig = {
  whitelistedDomains: [
    "bendhsa.com",
    "hsabank.com",
    "www.hsabank.com",
    "hsabank.bynder.com",
    "drivewealth.com",
    "dzb6emi8pracf.cloudfront.net", // drivewealth documents (UAT)
    "d1x2xpyby6kyfa.cloudfront.net", // drivewealth documents
    "s3.amazonaws.com",
    "live-test-domain.com" // test environments
  ]
};

export default config;